<div class="global-card" *ngIf="library">
    <img loading="lazy" class="community_img" [src]="imgURL"
        [alt]="library.name" onerror="this.src='/media/images/custom/defualt-img.jpg'">
    <div class="texts">
        <h3>{{ library.name }}</h3>
    </div>
    <div class="buttons justify-content-start">
        <a [routerLink]="['/browse-index']" [queryParams]="{ library: library.id }" class="btn-primary without-min" translate="READ_MORE"></a>
    </div>
</div>